import { render, staticRenderFns } from "./DisclosuresModal.vue?vue&type=template&id=50a857a4"
import script from "./DisclosuresModal.vue?vue&type=script&lang=js"
export * from "./DisclosuresModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports